import { render, staticRenderFns } from "./BookmarkedMatches.vue?vue&type=template&id=ecfec34a&"
import script from "./BookmarkedMatches.vue?vue&type=script&lang=js&"
export * from "./BookmarkedMatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports